/* eslint-disable no-param-reassign, no-alert */
import { useEffect } from 'react';

type Options = { when: boolean; message: string };
/**
 * This hook is NOT router-aware. It only prevents closing of windows and tabs, NOT navigating away
 * via React Router.
 */
export const useSimpleConfirm = ({ when, message }: Options) => {
  useEffect(() => {
    const listener = (event: BeforeUnloadEvent) => {
      if (when && !window.confirm(message)) {
        event.preventDefault();
        event.returnValue = true;
        return 'block';
      }
      return undefined;
    };
    window.addEventListener('beforeunload', listener);
    return () => {
      window.removeEventListener('beforeunload', listener);
    };
  }, [message, when]);
};
